<section class="landing-page container-fluid p-5">
  <div class="h-100 d-flex align-items-center flex-column">
    <div class="row">
      <div class="card" style="max-width: 60rem;">
        <div class="card-body">
          <h2 class="card-title text-center mb-4">Datenschutz bezüglich Google APIs</h2>
          <p class="card-text">
            Im Rahmen unseres Tippspiels kannst du deinen YouTube-Account verbinden. Dies ermöglicht es uns, deinen YouTube-Mitgliedsstatus zu überprüfen. Wir speichern dazu notwendige Informationen, um deinen YouTube-Kanal eindeutig identifizieren zu können. Weitere Informationen werden nicht gespeichert.
          </p>
          <p>
            Wir entsprechen somit der <a href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes">Google API Services User Data Policy</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
